/**
 *
 * @file 户型库api
 *
 **/

import AXIOS from '@/utils/$axios';

const withUid = fn => {
    let userStr = sessionStorage.getItem('hdcUserInfo');
    const { userId } = (userStr && JSON.parse(userStr)) || {};
    return fn(userId);
};
// 获取筛选条件
export const getFilterCondition = data =>
    withUid(userId =>
        AXIOS.post('/lws/common/group-attr', { ...data, userId })
    );

// 获取所有类型
export const getAllCategory = data =>
    withUid(userId =>
        AXIOS.post('/lws/common/get-all-category', { ...data, userId })
    );
